"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const php_date_formatter_1 = __importDefault(require("php-date-formatter"));
const app_1 = __importDefault(require("../app"));
require("select2");
class FormPlugin {
    constructor() {
        this.reloadTimers = [];
        if (jquery_1.default.fn.select2) {
            (0, jquery_1.default)(document).on("select2:open", () => {
                setTimeout(() => { var _a; return (_a = (0, jquery_1.default)(".select2-container--open .select2-search__field").get(0)) === null || _a === void 0 ? void 0 : _a.focus(); }, 50);
            });
        }
    }
    init() {
        this.refresh(document);
    }
    refresh(node) {
        if (typeof jquery_1.default.fn.datetimepicker === "function") {
            (0, jquery_1.default)(node).find(".datepicker, input[type=date]").each((index, item) => {
                const options = {
                    lang: "de",
                    lazyInit: true,
                    // weeks: true,
                    dayOfWeekStart: 1,
                    format: "Y-m-d",
                    timepicker: false,
                    datepicker: true,
                    ...(0, jquery_1.default)(item).data("options")
                };
                if (options.lang) {
                    jquery_1.default.datetimepicker.setLocale(options.lang);
                }
                (0, jquery_1.default)(item).data("options", options).datetimepicker(options);
            });
        }
        (0, jquery_1.default)(node).find("input.js-datetimepicker, input[type=time]").each((index, item) => {
            const options = {
                lang: "de",
                lazyInit: true,
                weeks: true,
                dayOfWeekStart: 1,
                format: "H:i",
                timepicker: true,
                datepicker: false,
                step: 60,
                ...(0, jquery_1.default)(item).data("options")
            };
            if (options.lang) {
                jquery_1.default.datetimepicker.setLocale(options.lang);
            }
            (0, jquery_1.default)(item).data("options", options).datetimepicker(options);
        });
        (0, jquery_1.default)(node).find(".js-datetimepicker-set").on("click", function (e) {
            const target = (0, jquery_1.default)((0, jquery_1.default)(this).data("target"));
            const value = new Date((0, jquery_1.default)(this).data("value") * 1000);
            const fmt = new php_date_formatter_1.default();
            target.val(fmt.formatDate(value, target.data("options").format));
            e.preventDefault();
        });
        (0, jquery_1.default)(node).find("form.reload-on-window-close").on("submit.formPlugin", (e) => {
            // eslint-disable-next-line no-script-url
            const targetWindow = window.open("javascript:void(window.opener.windowname = window);", (0, jquery_1.default)(e.target).attr("target"));
            const reloadCheck = function (subWindow) {
                if (subWindow.closed) {
                    app_1.default.goTo(window.location.href);
                    return;
                }
                this.reloadTimers.push(window.setTimeout(reloadCheck.bind(this, subWindow), 250));
            };
            if (targetWindow) {
                this.reloadTimers.push(window.setTimeout(reloadCheck.bind(this, targetWindow), 250));
            }
        });
        if (jquery_1.default.fn.select2) {
            (0, jquery_1.default)(node).find("select.sa-select2").each(function () {
                // @see https://select2.org/troubleshooting/common-problems#select2-does-not-function-properly-when-i-use-it-inside-a-bootst
                const isInsideModal = (0, jquery_1.default)(this).parents(".modal").length > 0;
                const dropdownParent = isInsideModal ? (0, jquery_1.default)(this).closest(".modal") : (0, jquery_1.default)("body");
                if ((0, jquery_1.default)(this).children('option[value=""]').length) {
                    (0, jquery_1.default)(this).select2({
                        placeholder: (0, jquery_1.default)(this).children('option[value=""]').text(),
                        allowClear: true,
                        width: (0, jquery_1.default)(this).data("width") || "100%",
                        dropdownParent
                    });
                }
                else {
                    (0, jquery_1.default)(this).select2({
                        width: (0, jquery_1.default)(this).data("width") || "100%",
                        dropdownParent
                    });
                }
            });
        }
    }
    destroy() {
        (0, jquery_1.default)("form.reload-on-window-close").off("submit.formPlugin");
        this.reloadTimers.forEach(timer => window.clearTimeout(timer));
        this.reloadTimers = [];
    }
}
exports.default = FormPlugin;
app_1.default.loadAndRegister("FormPlugin", FormPlugin);
